import { render, staticRenderFns } from "./AssignCategoriesDialog.vue?vue&type=template&id=288b0109&scoped=true&"
import script from "./AssignCategoriesDialog.vue?vue&type=script&lang=js&"
export * from "./AssignCategoriesDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignCategoriesDialog.vue?vue&type=style&index=0&id=288b0109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b0109",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
